import cn from "classnames";
import InlineBtn from "components/shared/inlineBtn";
import PanelTemplate from "components/shared/profile/panel";
import { validateForm } from "helpers/form";
import React from "react";
import { config, initialState } from "./config";

class EducationResourcesForm extends PanelTemplate {
    renderBody = () => {
        const { config } = this.props;
        const { data } = this.state;

        return (
            <div className="pb-3">
                {(data.resources || []).map((item, i) => {
                    const onChange = ({ name, value }) => {
                        const newValue = data.resources.map((item, index) =>
                            index === i ? { ...item, [name]: value } : item,
                        );
                        this.setValue({ name: "resources", value: newValue });
                    };
                    return (
                        <div className="pb-2" key={i}>
                            {this.renderField({ ...config.resources.config.name, onChange, value: item.name })}
                            {this.renderField({ ...config.resources.config.link, onChange, value: item.link })}
                            <div className="d-flex justify-content-end">
                                <div className="btn btn-sm btn-outline-danger" onClick={this.removeItem.bind(this, i)}>
                                    Удалить
                                </div>
                            </div>
                            <hr />
                        </div>
                    );
                })}
                <InlineBtn value="Добавить" cname="plus" action={this.addItem} />
            </div>
        );
    };

    addItem = () => {
        const { data } = this.state;
        const newValue = [...(data.resources || []), { name: "", link: "" }];
        this.setValue({ name: "resources", value: newValue });
    };

    removeItem = (i) => {
        const { data } = this.state;
        const newValue = data.resources.filter((_, index) => index !== i);
        this.setValue({ name: "resources", value: newValue });
    };

    setValue = ({ value, name }) => {
        const data = { ...this.state.data, [name]: value };
        const shouldUpdate = this.compareStateAndProps(this.props.data, data);
        const isValid = this.isValidForm(data);
        this.setState({ data, shouldUpdate, ...(isValid ? { isValid: true } : {}) });
    };

    isValidForm = (state) => {
        const { config } = this.props;
        return validateForm(config, state);
    };

    update = () => {
        const { shouldUpdate, data } = this.state;
        if (shouldUpdate && this.isValidForm(data)) {
            return this.props.action(data).then(() => this.setState({ shouldUpdate: false }));
        }
        this.setState({ isValid: false });
    };

    render() {
        const cname = cn("card card-body mb-3", {
            "border-danger book-form__body--invalid": !this.state.isValid,
        });
        return (
            <div className={cname}>
                <h5 className="mb-4">Обучающие ресурсы водителей</h5>
                {this.renderBody()}
                {this.renderButton()}
            </div>
        );
    }
}

const ConfiguredPanel = (props) => <EducationResourcesForm {...props} config={config} initialState={initialState} />;

export default ConfiguredPanel;
